export const EVENT_BUS_SESSION_AI_AGENTS_CHANGED = 'gd.session.aiAgents:change'
